"use client";

import Link from "next/link";
import { Button } from "@workspace/ui/components/button";
import { Card, CardContent } from "@workspace/ui/components/card";
import { ExternalLink } from "lucide-react";
import { cn } from "@workspace/ui/lib/utils";

export type FeaturedLinkProps = {
  title: string;
  href: string;
  description?: string;
  cta?: string;
  className?: string;
  onClick?: () => void;
};

export function FeaturedLink({
  title,
  href,
  description,
  cta = "Check it out",
  className,
  onClick,
}: FeaturedLinkProps) {
  const isExternal = /^https?:\/\//i.test(href);

  const Content = (
    <div className="flex w-full flex-col md:flex-row md:items-center justify-between gap-4">
      <div className="min-w-0 space-y-1">
        {/* <div className="flex items-center gap-2">
          <Badge variant="secondary" className="px-1.5 py-0 text-[10px] uppercase bg-gradient-to-b from-amber-400 to-amber-500 text-white">Featured</Badge>
        </div> */}
        <h3 className="truncate text-base font-semibold leading-tight">{title}</h3>
        {description ? (
          <p className="text-sm text-muted-foreground">{description}</p>
        ) : null}
      </div>
      <Button size="sm" className="shrink-0 self-center w-full md:w-auto bg-gradient-to-b from-amber-500 to-amber-600 text-white" asChild>
        {isExternal ? (
          <a href={href} target="_blank" rel="noopener noreferrer" onClick={onClick}>
            {cta}
            <ExternalLink className="ml-1.5 h-3.5 w-3.5" />
          </a>
        ) : (
          <Link href={href} onClick={onClick}>{cta}</Link>
        )}
      </Button>
    </div>
  );

  return (
    <Card
      className={cn(
        // Yellow-focused border + gradient background
        "py-0 md:py-1",
        "border-amber-300/70 bg-gradient-to-b from-amber-100/60 to-transparent",
        "hover:from-amber-100 transition-colors dark:from-amber-400/10 dark:hover:from-amber-400/15",
        className
      )}
    >
      <CardContent className="p-3 sm:p-4">{Content}</CardContent>
    </Card>
  );
}
